var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-university"},[_c('BreadCrumb',{attrs:{"data":_vm.breadcrumb,"title":'News列表管理'}}),_vm._v(" "),_c('ModuleClassfication',{staticClass:"pc-Article-tab",attrs:{"title":_vm.titles},on:{"addTopic":_vm.addTopic,"updateTopic":_vm.updateTopic,"deleteTopic":_vm.deleteTopic}}),_vm._v(" "),_c('MagazineArticleTable')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b6cc25","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/guihua/newsLatterList.vue
// module id = LXiX
// module chunks = 0